export const USA_CALENDAR_FIFTEEN = 'gid://shopify/ProductVariant/40416983416884'
export const USA_BLACK_FRAME = 'gid://shopify/ProductVariant/41022774575156'
